import axios from "axios"

const apiServer = axios.create({
  baseURL: "https://open.portalbrimoveis.com.br",
  headers: {
    "Content-Type": "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.cTdUMktVOHdDUTlU.p0Hg-mOUGX_kbkxqj31kcgllzhgNWr5pWYnx9mEbPdQ"
  }
})

export default apiServer
